import { ConfiguredWorkflows, SelfServiceType } from 'modules/selfServices/types/SelfService';

import type { Step } from 'types/Step';
import { SelfServiceSteps } from 'modules/selfServices/types/SelfServiceSteps';

import Login from './Login';
import LoginVerify from './LoginVerify';
import BreakdownInstructions from '../BreakdownInstructions';

type VisibleParams = {
  type: SelfServiceType,
  workflows: ConfiguredWorkflows,
};

type StepData = {
  isVisible: boolean | ((params: VisibleParams) => boolean),
};

export type LoginStep = Step<StepData>;

export const LOGIN_STEPS: LoginStep[] = [
  {
    key: SelfServiceSteps.INSTRUCTIONS,
    component: BreakdownInstructions,
    next: SelfServiceSteps.LOGIN,
    data: {
      hideHeader: true,
      isVisible: ({ type, workflows }) => (
        type === SelfServiceType.BREAKDOWN && workflows[SelfServiceType.BREAKDOWN]?.includes(SelfServiceSteps.INSTRUCTIONS)
      )
    },
  },
  {
    key: SelfServiceSteps.LOGIN,
    component: Login,
    next: SelfServiceSteps.VERIFY,
    previous: SelfServiceSteps.INSTRUCTIONS,
    data: {
      hideHeader: true,
      isVisible: true,
    },
  },
  {
    key: SelfServiceSteps.VERIFY,
    component: LoginVerify,
    // In the login component, we redirect to the other pages, so the only way to get this step is by doing a login MFA
    previous: SelfServiceSteps.LOGIN,
    data: {
      hideHeader: true,
      isVisible: true,
    },
  },
];
